import { IndexableObject } from '../types/ObjectTypes';
import createChainablePropType from './createChainablePropType';

const domElementPropType = (
  props: IndexableObject,
  propName: string,
  componentName: string
): Error | null => {
  const value = props[propName];
  if (value == null || (typeof value === 'object' && value.nodeType === 1))
    return null;
  return new Error(
    `${componentName}: Invalid ${propName} value. Expected a DOM element.`
  );
};

export default createChainablePropType(domElementPropType, 'DOM element');
